import createSvgIcon from '../Utils/CreateSvgIcon';

export const AwardStar = createSvgIcon(
  <path d="m382.42-340.15 97.63-59.35 97.91 59.35-26.27-111.16 86.5-74.15-113.35-10.33L480-639.85l-44.74 104.06-113.07 10.33 86.12 74.15-25.89 111.16ZM480-91.38 365.31-206.15H206.15v-159.16L91.38-480l114.77-114.69v-159.16h159.16L480-868.62l114.69 114.77h159.16v159.16L868.62-480 753.85-365.31v159.16H594.69L480-91.38Zm0-52.31 99.38-99.39h137.54v-137.54L816.31-480l-99.39-99.38v-137.54H579.38L480-816.31l-99.38 99.39H243.08v137.54L143.69-480l99.39 99.38v137.54h137.54L480-143.69ZM480-480Z" />,
  'AwardStar',
  '0 -960 960 960',
);
